export default __webpack_public_path__ + "static/media/adCategory.49494944.svg";